import { createAsyncThunk } from "@reduxjs/toolkit";
import { getOpSiteDetails, getEmissionAlerts, getAssetHierarchy, getAssetAlerts, getUserPreferences, getHeatMapData } from "../../config/services/ApiServices";

export const fetchSiteDetails = createAsyncThunk('site-details/fetch', async ({ startDate, endDate, timeZone }: { startDate: Date, endDate: Date, timeZone: string }) => {
    const response = await getOpSiteDetails({ startDate, endDate });
    return response;
})

export const fetchEmissionAlerts = createAsyncThunk('emissionAlert-details/fetch', async ({ startDate, endDate }: { startDate: Date, endDate: Date }) => {
    const response = await getEmissionAlerts({ startDate, endDate });
    return response;
})

export const fetchAssetAlerts = createAsyncThunk('assetAlerts-details/fetch', async ({ startDate }: { startDate: Date }) => {
    const response = await getAssetAlerts({ startDate });
    return response;
})

export const fetchAssetHierarchy = createAsyncThunk('asset-hierarchy/fetch', async () => {
    const response = await getAssetHierarchy();
    return response
})

export const fetchHeatMap = createAsyncThunk('heat-map/fetch', async ({ siteId, siteName, customerId="", customerName, region, startTime, endTime, units, comparison, threshold }: { siteId: string, siteName: string, customerId: string, customerName:string, region:string, startTime:Date ,endTime:Date, units: string, comparison: string, threshold: string}) => {
    const response = await getHeatMapData({ siteId, siteName, customerId, customerName, region, startTime, endTime, units, comparison, threshold });
    return response
})
